import { useEffect, useRef, useState } from 'react';
import { useActions } from '../providers/actions-provider/actions.context';
import { assetIconCache } from '../../store/services/asset-icon-cache/asset-icon-cache';

interface IUseAssetIcon {
  url: string | null;
  loading: boolean;
}

export const useAssetIcon = (assetTypeCode?: string): IUseAssetIcon => {
  const { assetActions } = useActions();
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [refreshKey, setRefreshKey] = useState<number>(0);
  const lastCodeRef = useRef<string | undefined>(undefined);

  useEffect(() => assetIconCache.subscribe(() => setRefreshKey((key) => key + 1)), []);

  useEffect(() => {
    if (!assetTypeCode) {
      lastCodeRef.current = assetTypeCode;
      setUrl(null);
      setLoading(false);
      return undefined;
    }

    let active = true;
    if (lastCodeRef.current !== assetTypeCode) {
      setUrl(null);
    }
    lastCodeRef.current = assetTypeCode;
    setLoading(true);

    assetIconCache
      .get(assetTypeCode, () => assetActions.fetchAssetIconBlob(assetTypeCode))
      .then((resolved) => {
        if (active) {
          setUrl(resolved);
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [assetTypeCode, assetActions, refreshKey]);

  return { url, loading };
};
